import {useContext} from "react";
import FloorplanContext from "../FloorplanContext";

export const useFloorplanContext = () => {
    const context = useContext(FloorplanContext);
    if (!context) {
        throw new Error('useFabricCanvas must be used within a FabricCanvasProvider');
    }
    return context;
};